import { render, staticRenderFns } from "./PensionUnitSelectionForm.vue?vue&type=template&id=41f0a453&scoped=true&"
import script from "./PensionUnitSelectionForm.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PensionUnitSelectionForm.vue?vue&type=style&index=0&id=41f0a453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f0a453",
  null
  
)

export default component.exports